// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.empdashboardview-inline-1 {
  border: 1px solid #fed7aa;
  background: #fff7ed;
}

.empdashboardview-inline-2 {
  color: #9a3412;
  font-weight: 700;
  font-size: 13px;
}

.empdashboardview-inline-3 {
  text-align: center;
}

.empdashboardview-inline-4 {
  font-size: 28px;
  font-weight: 800;
  color: #4f46e5;
  margin-bottom: 2px;
}

.empdashboardview-inline-5 {
  font-size: 12px;
  color: #94a3b8;
}

.empdashboardview-inline-6 {
  text-align: center;
}

.empdashboardview-inline-7 {
  margin-bottom: 4px;
}

.empdashboardview-inline-8 {
  font-size: 24px;
  font-weight: 800;
  color: #4f46e5;
}

.empdashboardview-inline-9 {
  font-size: 13px;
  color: #94a3b8;
}

.empdashboardview-inline-10 {
  font-size: 12px;
  color: #2563eb;
  font-weight: 600;
}

.empdashboardview-inline-11 {
  margin-top: 8px;
  border-top: 1px solid #e2e8f0;
  padding-top: 8px;
}

.empdashboardview-inline-12 {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  padding: 3px 0;
}

.empdashboardview-inline-13 {
  font-weight: 600;
}

.empdashboardview-inline-14 {
  font-size: 10px;
}

.empdashboardview-inline-15 {
  margin-top: 4px;
}

.empdashboardview-inline-16 {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  padding: 3px 0;
}

.empdashboardview-inline-17 {
  font-size: 10px;
}

.empdashboardview-inline-18 {
  text-align: center;
}

.empdashboardview-inline-19 {
  font-size: 14px;
  color: #94a3b8;
}

.empdashboardview-inline-20 {
  font-size: 12px;
  color: #94a3b8;
}

.empdashboardview-inline-21 {
  font-size: 11px;
  color: #f59e0b;
  margin-top: 4px;
}

.empdashboardview-inline-22 {
  text-align: center;
  color: #94a3b8;
  padding: 16px;
  font-size: 13px;
}

.empdashboardview-dyn-1 {
  color: var(--empdashboardview-1-color);
}

.empdashboardview-dyn-2 {
  color: var(--empdashboardview-2-color);
  font-size: 18px;
}

.empdashboardview-dyn-3 {
  color: var(--empdashboardview-3-color);
  font-size: var(--empdashboardview-3-font-size);
}

.empdashboardview-dyn-4 {
  font-size: 28px;
  font-weight: 800;
  color: var(--empdashboardview-4-color);
  margin-bottom: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/Employee/EmpDashboardView.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sCAAsC;EACtC,kBAAkB;AACpB","sourcesContent":[".empdashboardview-inline-1 {\n  border: 1px solid #fed7aa;\n  background: #fff7ed;\n}\n\n.empdashboardview-inline-2 {\n  color: #9a3412;\n  font-weight: 700;\n  font-size: 13px;\n}\n\n.empdashboardview-inline-3 {\n  text-align: center;\n}\n\n.empdashboardview-inline-4 {\n  font-size: 28px;\n  font-weight: 800;\n  color: #4f46e5;\n  margin-bottom: 2px;\n}\n\n.empdashboardview-inline-5 {\n  font-size: 12px;\n  color: #94a3b8;\n}\n\n.empdashboardview-inline-6 {\n  text-align: center;\n}\n\n.empdashboardview-inline-7 {\n  margin-bottom: 4px;\n}\n\n.empdashboardview-inline-8 {\n  font-size: 24px;\n  font-weight: 800;\n  color: #4f46e5;\n}\n\n.empdashboardview-inline-9 {\n  font-size: 13px;\n  color: #94a3b8;\n}\n\n.empdashboardview-inline-10 {\n  font-size: 12px;\n  color: #2563eb;\n  font-weight: 600;\n}\n\n.empdashboardview-inline-11 {\n  margin-top: 8px;\n  border-top: 1px solid #e2e8f0;\n  padding-top: 8px;\n}\n\n.empdashboardview-inline-12 {\n  display: flex;\n  justify-content: space-between;\n  font-size: 12px;\n  padding: 3px 0;\n}\n\n.empdashboardview-inline-13 {\n  font-weight: 600;\n}\n\n.empdashboardview-inline-14 {\n  font-size: 10px;\n}\n\n.empdashboardview-inline-15 {\n  margin-top: 4px;\n}\n\n.empdashboardview-inline-16 {\n  display: flex;\n  justify-content: space-between;\n  font-size: 12px;\n  padding: 3px 0;\n}\n\n.empdashboardview-inline-17 {\n  font-size: 10px;\n}\n\n.empdashboardview-inline-18 {\n  text-align: center;\n}\n\n.empdashboardview-inline-19 {\n  font-size: 14px;\n  color: #94a3b8;\n}\n\n.empdashboardview-inline-20 {\n  font-size: 12px;\n  color: #94a3b8;\n}\n\n.empdashboardview-inline-21 {\n  font-size: 11px;\n  color: #f59e0b;\n  margin-top: 4px;\n}\n\n.empdashboardview-inline-22 {\n  text-align: center;\n  color: #94a3b8;\n  padding: 16px;\n  font-size: 13px;\n}\n\n.empdashboardview-dyn-1 {\n  color: var(--empdashboardview-1-color);\n}\n\n.empdashboardview-dyn-2 {\n  color: var(--empdashboardview-2-color);\n  font-size: 18px;\n}\n\n.empdashboardview-dyn-3 {\n  color: var(--empdashboardview-3-color);\n  font-size: var(--empdashboardview-3-font-size);\n}\n\n.empdashboardview-dyn-4 {\n  font-size: 28px;\n  font-weight: 800;\n  color: var(--empdashboardview-4-color);\n  margin-bottom: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
